/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const calendarColorStyle = {
    primary: {
        main: '#000000',
        800: '#262626',
        700: '#434343',
        600: '#555555',
        200: '#D9D9D9',
        100: '#E9E9E9',
    },
    common: {
        arrows: '#2F363D',
        default: '#FFFFFF',
        error: '#DF3030',
        selection: '#FAFAFA',
        white: '#FFFFFF',
    },
};

export default {};
